<template>
	<v-dialog
    class="dialog-elevation-0"
    content-class="elevation-0"
		v-model="dialog"
		width="1200"
	>
		<template v-slot:activator="{ attrs, on }">
			<v-btn
				color="grey"
				text
				v-bind="attrs"
				v-on="on"
			><v-icon class="mr-3">mdi-arrow-expand-all</v-icon>拡大</v-btn>
		</template>

    <v-btn dark fab icon style="background-color: rgba(0, 0, 0, 0.5); position: fixed; top: 50px; left: 50px;" @click="dialog=false">
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <pics-slider :pics="pics" width="1300" height="600"/>
	</v-dialog>
</template>

<script>
import PicsSlider from '../components/PicsSlider'
import windowSizeMixin from '../../../mixin/windowSizeMixin'

export default {
  mixins: [windowSizeMixin],
  components: {
		PicsSlider,
	},
	data: () => ({
		dialog: false,
	}),
  props: {
    pics: {
      require: true,
      type: Array,
    },
  },
}
</script>